module.exports = __webpack_public_path__ + "img/news6-1.c4c874d1.png";